var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":"https://performancehub.prod.hyrox.fiit-tech.net/","frameBorder":"0"}})])
}]

export { render, staticRenderFns }